// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2Au5c","label":"style_label__ffq68"};